<template>
	<Dialog v-model:visible="calculadoraDeCaixa.visible.value" v-focustrap header="Calculadora de Caixa" modal
		class="w-full" @hide="calculadoraDeCaixa.visible.value = false">

		<R3Div class="flex flex-column">
			<R3Div class="flex flex-row w-full">
				<!-- Lastro -->
				<R3Div>
					<R3FieldSet title="lastro">
						<R3InputNumber :ref="calculadoraDeCaixa.lastro" />
					</R3FieldSet>
				</R3Div>
				<!-- Camada -->
				<R3Div>
					<R3FieldSet title="Camada">
						<R3InputNumber :ref="calculadoraDeCaixa.camada" />
					</R3FieldSet>
				</R3Div>
				<!-- Caixas Soltas -->
				<R3Div>
					<R3FieldSet title="Cx Solta">
						<R3InputNumber :ref="calculadoraDeCaixa.caixaSolta" />
					</R3FieldSet>
				</R3Div>
			</R3Div>
			<R3Div class="flex flex-row w-full mt-2 align-items-center">
				<!-- Total -->
				<R3Div class="flex w-9">
					<R3FieldSet>
						{{ calculadoraDeCaixa.total.value }}
					</R3FieldSet>
				</R3Div>
				<!-- Botão ocupa o espaço restante e alinha à direita -->
				<R3Div class="flex flex-1 justify-content-end ml-4">
					<R3Button class="w-full max-w-xs" icon="pi pi-check" @click="onTerminarCalculo" />
				</R3Div>
			</R3Div>
		</R3Div>
	</Dialog>

</template>

<script lang="ts" setup>
	// {$R globalDialogs/calculadoraDeCaixa.vue}
	import type { GlobalDialogs } from '~/classes/globalDialogs/globalDialogs';

	const { calculadoraDeCaixa, handleResponse } = useCalculadoraDeCaixa();

	const props = defineProps<{
		parent?: GlobalDialogs
	}>()

	function onTerminarCalculo() {
		// const totalCaixas = calcularTotalCaixas()
		return handleResponse(calculadoraDeCaixa.total.value);
	}


</script>

<style lang="scss"></style>